( function() {
  const recaptchaKeyValue = window.recaptchaKeyValue;

  // If no reCAPTCHA key is configured, don't run any blocking logic
  if ( ! recaptchaKeyValue ) {
    return;
  }

  const SEL = {
    formClass: 'wpcf7-form',
    responseInputSelector: 'input[name="_wpcf7_recaptcha_response"]',
    recaptchaKey: recaptchaKeyValue ? recaptchaKeyValue : '6LeNSt4aAAAAAD77kpg3Flev54gIrW8yNDgK-3-F',
    recaptchaVersion: '3.0',
    pathToWpcf7Script: '/wp-content/plugins/contact-form-7/modules/recaptcha/index.js',
    formExceptionClass: 'cvle-no-captcha',
    cvleEnableSubmit: 'cvle-enable-submit',
  };
  const wpcf7Recaptcha = { sitekey: SEL.recaptchaKey };
  let wpcf7FormsSelector = '.' + SEL.formClass;
  if ( SEL.formExceptionClass && SEL.formExceptionClass.length > 0 ) {
    wpcf7FormsSelector += `:not(.${ SEL.formExceptionClass })`;
  }
  const wpcf7Forms = document.querySelectorAll( wpcf7FormsSelector );
  let wpcf7EventIsAdded = false;

  if ( ! wpcf7Forms.length ) {
    return;
  }

  // Load defered jQuery and cf7mls-js
  document.addEventListener( 'mousemove', addCF7Scripts );
  document.addEventListener( 'keyup', addCF7Scripts );
  document.addEventListener( 'click', addCF7Scripts );
  setTimeout( addCF7Scripts, 7000 );

  let clickOnFormsExecuted = false;

  /**
   * Triggers a click event on each Contact Form 7 form to invoke the addDeferRecaptcha function.
   * This function is executed only once when any of the following events occur:
   * - Mousemove
   * - Scroll
   * - Touchstart
   *
   * This helps to ensure that addDeferRecaptcha is also invoked on various devices and in different scenarios.
   * @param {Event} e - event
   */
  function clickOnForms( e ) {
    if ( ! clickOnFormsExecuted ) {
      wpcf7Forms.forEach( ( form ) => {
        form.click();
      } );
      document.removeEventListener( e.type, clickOnForms );
      clickOnFormsExecuted = true;
    }
  }

  document.addEventListener( 'mousemove', clickOnForms );
  document.addEventListener( 'scroll', clickOnForms );
  document.addEventListener( 'touchstart', clickOnForms );

  /**
   * Waits for grecaptcha to load (if grecaptcha isn't loaded launches itself again after the interval),
   * then enables CF7 form elements.
   */
  function enableCF7() {
    if ( ! window.grecaptcha ) {
      setTimeout( enableCF7, 200 );
      return;
    }

    wpcf7Forms.forEach( ( form ) => {
      form.classList.add( SEL.cvleEnableSubmit );
      const wcf7inputs = form.querySelectorAll( 'input, textarea, select, button' );
      wcf7inputs.forEach( ( formElement ) => {
        if ( ! formElement.classList.contains( 'js-stay-disabled' ) ) {
          formElement.disabled = false;
        }
      } );
    } );

    // for elements which are not inside the cf7
    document.querySelectorAll( '.js-remove-disabled' ).forEach( ( elem ) => {
      elem.disabled = false;
    } );
  }

  wpcf7Forms.forEach( ( form ) => form.addEventListener( 'click', addDeferRecaptcha ) );

  setTimeout( () => {
    wpcf7Forms.forEach( ( form ) => {
      addDeferRecaptcha( { currentTarget: form } );
    } );
  }, 7000 );

  /**
   * @function executeWpcf7Script execute wpcf7 recaptcha when form fires change event
   * @param {Object} form form node
   */
  function executeWpcf7Script( form ) {
    wpcf7Recaptcha.execute = recaptchaExecute;

    form.addEventListener( 'change', function() {
      wpcf7Recaptcha.execute( 'page' );
    } );

    if ( ! wpcf7EventIsAdded ) {
      document.addEventListener( 'wpcf7submit', function() {
        wpcf7Recaptcha.execute( 'page' );
      } );
      document.addEventListener( 'wpcf7grecaptchaexecuted', recaptchaExecutedHandler );

      wpcf7EventIsAdded = ! wpcf7EventIsAdded;
    }
  }

  /**
   * @function recaptchaExecute executing function
   * @param {string} action string defines where to execute recaptcha
   */
  function recaptchaExecute( action ) {
    if ( ! window.grecaptcha ) {
      return;
    }
    window.grecaptcha.execute(
      wpcf7Recaptcha.sitekey,
      { action }
    ).then( function( token ) {
      const event = new window.CustomEvent( 'wpcf7grecaptchaexecuted', {
        detail: {
          action,
          token,
        },
      } );

      document.dispatchEvent( event );
    } );
  }

  /**
   * @function recaptchaExecutedHandler puts token to form hidden input
   * @param {Object} event event object
   */
  function recaptchaExecutedHandler( event ) {
    const fields = document.querySelectorAll(
      `form.${ SEL.formClass } ${ SEL.responseInputSelector }`
    );

    for ( let i = 0; i < fields.length; i++ ) {
      const field = fields[ i ];
      field.setAttribute( 'value', event.detail.token );
    }
  }

  /**
   * @function addDeferRecaptcha creates and addsrecaptcha scripts
   * @param {Object} e event object
   */
  function addDeferRecaptcha( e ) {
    const googleRecaptchaScript = document.getElementById( 'google-recaptcha-js' );
    const wpcf7RecaptchaScript = document.getElementById( 'wpcf7-recaptcha-js' );
    const currentFormForRecaptcha = e.currentTarget;

    if ( googleRecaptchaScript && wpcf7RecaptchaScript ) {
      executeWpcf7Script( currentFormForRecaptcha );
    } else if ( ! googleRecaptchaScript ) {
      const newGoogleRecaptchaScript = generateScript( 'https://www.google.com/recaptcha/api.js?render=' + SEL.recaptchaKey + '&ver=' + SEL.recaptchaVersion, 'google-recaptcha-js', true );
      if ( wpcf7RecaptchaScript ) {
        newGoogleRecaptchaScript.onload = () => {
          executeWpcf7Script( currentFormForRecaptcha );
        };
      } else {
        newGoogleRecaptchaScript.onload = function() {
          const newWpcf7RecaptchaScript = generateScript( SEL.pathToWpcf7Script, 'wpcf7-recaptcha-js', true );
          newWpcf7RecaptchaScript.onload = () => {
            executeWpcf7Script( currentFormForRecaptcha );
          };
        };
      }
    }

    enableCF7();
    e.currentTarget.removeEventListener( 'click', addDeferRecaptcha );
  }

  /**
   * @function addCF7Scripts creates and adds jQuery and multistep scripts
   * @param {Object} event event object
   */
  function addCF7Scripts( event ) {
    if ( ! window.cvleCf7mls ) {
      return;
    }
    const jqueryScript = document.getElementById( 'jquery-core-js' );
    if ( ! jqueryScript && window.cvleCf7mls.jquerySrc ) {
      const newJqueryScript = generateScript( window.cvleCf7mls.jquerySrc, 'jquery-core-js', true );
      newJqueryScript.onload = function() {
        addMultiStepScripts( event );
      };
    } else {
      addMultiStepScripts( event );
    }
    document.removeEventListener( 'mousemove', addCF7Scripts );
    document.removeEventListener( 'keyup', addCF7Scripts );
    document.removeEventListener( 'click', addCF7Scripts );
  }

  /**
   * @function addCF7Scripts creates and adds multistep script
   * @param {Object} event event object
   */
  function addMultiStepScripts( event ) {
    const cf7mlsScript = document.getElementById( 'cf7mls-js' );
    if ( ! cf7mlsScript && window.cvleCf7mls.cf7mlsSrc ) {
      const newCf7mlsScript = generateScript( window.cvleCf7mls.cf7mlsSrc, 'cf7mls-js', true );
      newCf7mlsScript.onload = function() {
        // Redo the initial click if this was a cf7mls click
        if ( event && event.target.classList.contains( 'cf7mls_btn' ) ) {
          // Waiting for cf7mls initialization - checking each half second
          const formStatusChecker = setInterval( function() {
            if ( event.target.closest( 'form' ).classList.contains( 'init' ) ) {
              event.target.click();
              clearInterval( formStatusChecker );
            }
          }, 500 );
        }
      };
    }
  }

  /**
   * @function generateScript creates script element and appends It to body after configuration
   * @param {string}  src   source
   * @param {string}  id    id for script tag
   * @param {boolean} defer is scirpt deferred
   * @return {HTMLElement} script element
   */
  function generateScript( src, id, defer = false ) {
    const scriptElement = document.createElement( 'script' );
    scriptElement.src = src;
    scriptElement.id = id;
    scriptElement.defer = defer;
    document.body.appendChild( scriptElement );
    return scriptElement;
  }
}() );

// Cloudflare Turnstile deferred loading
( function() {
  const turnstileWidget = document.querySelector( '.wpcf7-turnstile.cf-turnstile' );

  // If no Turnstile sitekey is configured, don't run any logic
  if ( ! turnstileWidget && ! turnstileWidget?.dataset?.sitekey ) {
    return;
  }

  const TURNSTILE_CONFIG = {
    scriptId: 'turnstile-js',
    // https://developers.cloudflare.com/turnstile/get-started/client-side-rendering/#1-add-the-turnstile-script
    scriptSrc: 'https://challenges.cloudflare.com/turnstile/v0/api.js',
    resetScriptId: 'turnstile-reset-handler',
  };

  let turnstileLoaded = false;
  let turnstileTimeout = null;

  /**
   * Loads Cloudflare Turnstile script and sets up reset handler
   * This function runs only once when triggered by user interaction or timeout
   */
  function loadTurnstile() {
    // Prevent multiple executions
    if ( turnstileLoaded ) {
      return;
    }

    // Remove event listeners so it runs only once
    document.removeEventListener( 'mousemove', loadTurnstile );
    document.removeEventListener( 'click', loadTurnstile );
    document.removeEventListener( 'keyup', loadTurnstile );

    // Clear the timeout if it exists
    if ( turnstileTimeout ) {
      clearTimeout( turnstileTimeout );
      turnstileTimeout = null;
    }

    // Check if script is already loaded
    if ( document.getElementById( TURNSTILE_CONFIG.scriptId ) ) {
      turnstileLoaded = true;
      return;
    }

    // Create and append Turnstile script
    const turnstileScript = document.createElement( 'script' );
    turnstileScript.src = TURNSTILE_CONFIG.scriptSrc;
    turnstileScript.id = TURNSTILE_CONFIG.scriptId;
    turnstileScript.defer = true;

    // Create reset handler script
    const resetScript = document.createElement( 'script' );
    resetScript.id = TURNSTILE_CONFIG.resetScriptId;
    resetScript.textContent = "document.addEventListener( 'wpcf7submit', function() { if ( window.turnstile ) { turnstile.reset(); } } );";

    turnstileScript.addEventListener( 'load', function() {
      turnstileLoaded = true;
    } );

    document.body.appendChild( turnstileScript );
    document.body.appendChild( resetScript );
  }

  // Set up event listeners for user interaction
  document.addEventListener( 'mousemove', loadTurnstile );
  document.addEventListener( 'click', loadTurnstile );
  document.addEventListener( 'keyup', loadTurnstile );

  // Fallback timeout: load after 5 seconds if no user interaction
  turnstileTimeout = setTimeout( loadTurnstile, 5000 );
}() );

// Focus on success message after form submission for accessibility
( function() {
  document.addEventListener( 'DOMContentLoaded', function() {
    const wpcf7Forms = document.querySelectorAll( '.wpcf7' );
    wpcf7Forms.forEach( function( form ) {
      form.addEventListener( 'wpcf7mailsent', function() {
        const successMsg = document.querySelector( '.ms-form__success' );
        if ( successMsg ) {
          // Ensure the element can receive focus
          successMsg.setAttribute( 'tabindex', '-1' );
          successMsg.focus();
        }
      }, false );
    } );
  } );
}() );
